import React from 'react';
import axios from 'axios';
import { Alert, Button, Spin } from 'antd';

import apiPath from 'apiPath';
import PaymentTriggerForm from 'components/PaymentTriggerForm';
import TransactionTable from 'components/TransactionTable';

export default class Insurance extends React.Component {
	state = {
		enrolled: null,
		enrolledHistory: [],
		justChangedTo: null
	}
	getEnrollmentStatus = () => {
		axios.get(apiPath+'/insurance', {withCredentials: true}).then(result => {
			this.setState({ enrolled: result.data === "E"});
		}).catch(this.props.handleAxiosLoadError);
	}
	getEnrollmentHistory = () => {
		axios.get(apiPath+'/insurance/history', {withCredentials: true}).then(result => {
			this.setState({ enrolledHistory: result.data});
		}).catch(this.props.handleAxiosLoadError);
	}
	changeEnrolled = (enrolled) => {
		axios.post(apiPath+'/insurance', {enrolled: enrolled}, {withCredentials: true}).then(result => {
			this.setState({ justChangedTo: enrolled });
			this.getEnrollmentStatus();
		}).catch(this.props.handleAxiosSaveError);
	}
	componentDidMount() {
		this.getEnrollmentStatus();
		if (this.props.variant === 'admin') this.getEnrollmentHistory();
	}
	componentWillReceiveProps(nextProps) {
		if (this.props.variant === 'admin') this.getEnrollmentHistory();
	}
	render() {
		const disabled = this.props.variant !== 'admin' && !this.props.sectionIsEnabled(this.props, 'financial/insurance');
		if (this.props.variant !== 'admin' && this.props.redirectIfHidden) {
			const redirect = this.props.redirectIfHidden(this.props, 'financial/insurance');
			if (redirect) return redirect;
		}

		const hasCharge = this.props.insuranceChargeTotal > 0;
		const hasPaid = this.props.insuranceChargeTotal > 0 && this.props.insuranceChargeTotal <= this.props.insuranceCreditTotal;
		const tableTransactions = this.props.insuranceTransactions
			.map(t => { t.Charge = t.Amount; return t; })
			.concat(this.props.insurancePayments.map(p => { p.Payment = p.Amount; return p; }))
			.sort((a,b) => a.id - b.id);
		return (
			<div>
				<Alert type="info" showIcon
					message="About the Program Fee Refund Plan"
					description={<span>
						A Semester at Sea represents a major investment for you in both time and money. We want to be
						certain that students have an opportunity to protect your financial commitment in the case of a serious
						illness or accident. In an effort to minimize any potential financial loss, Semester at Sea has arranged
						with A.W.G. Dewar, Inc. to provide an insurance program (the Program Fee Refund Plan) that will
						provide coverage for the Program Fee if medical problems, including mental health issues, require
						withdrawal from the Program before the semester voyage ends. Semester at Sea's Program Fee
						includes the cost of tuition (which includes required field classes), room and board, and travel health
						insurance-- less financial aid. The Program Fee does not include the cost of Semester at Sea field
						excursions, on-board purchases, fuel surcharges, or independent travel.
						<br /><br />
						Students enrolled on this voyage will be automatically enrolled in the Program Fee Refund Plan.
						If you do not wish to participate in the Program Fee Refund Plan please make the appropriate changes below.
					</span>}/>
				<br />
				{(this.state.enrolled === null)?
					<Spin />
				:
					<Alert
						type={(this.state.enrolled && hasPaid)? 'success': (this.state.enrolled)? 'error': 'warning'} showIcon
						message={"Current Status: " + ((this.state.enrolled && hasPaid)? 'Enrolled and paid': (this.state.enrolled)? 'Enrolled but not paid': 'Not enrolled')}
						description={(this.state.enrolled)?
							<span>
								You are enrolled in the Program Fee Refund Plan
								<br /><br />
								{!hasPaid &&
									<Button disabled={disabled} onClick={() => this.changeEnrolled(false)}>Un-enroll</Button>
								}
							</span>
							:
							<span>
								You are not enrolled in the Program Fee Refund Plan
								<br /><br />
								<Button disabled={disabled} type="primary" onClick={() => this.changeEnrolled(true)}>Enroll</Button>
							</span>
						} />
				}
				<br />
				{(this.state.justChangedTo === true || (this.state.enrolled && !hasCharge)) && <Alert showIcon type="info" message="If you have just enrolled, the charge on your account may take up to 24 hours to update. After that, please come back to make your payment." />}
				{this.state.justChangedTo === false && <Alert showIcon type="info" message="If you have just un-enrolled, it may take up to 24 hours for the the charge to be removed from your account." />}
				
				{/* {this.state.enrolled && hasCharge && !hasPaid && */}
				
				{hasCharge && !hasPaid &&
					<PaymentTriggerForm showIcon

						disabled={false || !this.props.transactionsLoaded}

						// disabled={disabled || !this.props.transactionsLoaded}
						kickSession={this.props.kickSession}
						booking={this.props.bookingLoaded && this.props.booking}
						refreshBooking={this.props.refreshBooking}
						orderno_prefix="INS"
						total={this.props.insuranceChargeTotal - this.props.insuranceCreditTotal}
						preCheckout={() => Promise.resolve(true)}
						buttonText={'Pay Passage Fare Insurance'}/>
				}
				<br />
				{tableTransactions.length > 0 &&
					<TransactionTable
						noNames
						variant={this.props.variant}
						chargeTotal={this.props.insuranceChargeTotal}
						creditTotal={this.props.insuranceCreditTotal}
						transactions={tableTransactions} />
				}
				<br />
				{this.props.variant === 'admin' &&
					<div>
						<h3>History</h3>
						<ul>
							{this.state.enrolledHistory.map(entry =>
								<li key={entry.RESPONSE_DATE}>{entry.STATUS_CODE} on {entry.RESPONSE_DATE}</li>
							)}
						</ul>
					</div>
				}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./portal-components/Portal/Financial/Insurance.jsx